export default __webpack_public_path__ + "static/media/FiraSans-Medium.9e604b4c.ttf";